export default "__VITE_ASSET__D2PaMp1c__"